module.exports = __webpack_public_path__ + "static/img/Planificaciones_2_tabla planif@4x.8492f61a.png";